/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var MppIcon = createIcon("MppIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#107C41';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.061 30V19.857L11.463 30h1.827l3.429-10.206V30h2.223V16.986h-3.114l-3.447 9.945-3.411-9.945H5.838V30h2.223Zm16.254 0v-4.716h2.682c2.772 0 4.617-1.512 4.617-4.095 0-2.727-2.097-4.203-4.905-4.203h-4.617V30h2.223Zm2.628-6.471h-2.646v-4.815h2.583c1.521 0 2.655.855 2.655 2.349 0 1.467-1.071 2.466-2.592 2.466ZM35.925 30v-4.716h2.682c2.772 0 4.617-1.512 4.617-4.095 0-2.727-2.097-4.203-4.905-4.203h-4.617V30h2.223Zm2.628-6.471h-2.646v-4.815h2.583c1.521 0 2.655.855 2.655 2.349 0 1.467-1.071 2.466-2.592 2.466Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.MppIcon",
  "replaceColor": true
});